import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface ApiResponse {
  data: { total: number };
}

export const getActivePatientsCount = async (username: string): Promise<number> => {
  const response: ApiResponse = await axios.get(apiEndpoints.METRICS_PROFESSIONAL_ACTIVE_PATIENTS(username))
  return response.data.total
}
